/**
 * Smart search select box
 */
admin.registerLoad(function (prefix) {

    $(prefix + '.js-pivot-toggler').each(function () {

        var $this = $(this);

        $this.change(function () {
            update();
        });
        update();

        function update()
        {
            if ($this.prop("checked"))
            {
                $this.closest("tr").find(".js-pivot-toggled").show();
            } else {
                $this.closest("tr").find(".js-pivot-toggled").hide();
            }
        }
    });

});